// ⚠️ AUTO-GENERATED FILE — DO NOT EDIT

import _defaultTranslation from '../locals/en/translation.json';
import _defaultLocale from '@angular/common/locales/en-GB';

export const defaultTranslation: Record<string, { translation: object }> = { 'en': { translation: _defaultTranslation } };
export const defaultLocale: Record<string, unknown[]> = { 'en': _defaultLocale };

export const bundledTranslationLoaders: Record<string, () => Promise<object>> = {
  'en': () => import('../locals/en/translation.json').then((m) => m.default ?? m),
};

export const bundledLocaleLoaders: Record<string, () => Promise<unknown>> = {
  'en': () => import('@angular/common/locales/en-GB').then((m) => m.default ?? m),
};

export async function loadBundledTranslation(languageCode: string): Promise<object | null> {
  const loader = bundledTranslationLoaders[languageCode];
  if (!loader) return null;
  return loader();
}

export async function loadBundledLocale(languageCode: string): Promise<unknown | null> {
  const loader = bundledLocaleLoaders[languageCode];
  if (!loader) return null;
  return loader();
}
